import React from 'react';

function HeaderRowIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				fill='#EDF876'
				d='M2 4a2 2 0 012-2h8a2 2 0 012 2v1a1 1 0 01-1 1H3a1 1 0 01-1-1V4z'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M2.594 13.406c-.927-.928-.927-2.42-.927-5.406 0-2.986 0-4.478.927-5.406.928-.927 2.42-.927 5.406-.927 2.986 0 4.478 0 5.406.927.927.928.927 2.42.927 5.406 0 2.986 0 4.478-.927 5.406-.928.927-2.42.927-5.406.927-2.986 0-4.478 0-5.406-.927z'
			></path>
			<path stroke='#141414' d='M1.667 6h12.666M1.667 10h12.666'></path>
		</svg>
	);
}

export default HeaderRowIcon;
